import { render, staticRenderFns } from "./InstantCreditForm.vue?vue&type=template&id=12c926da&scoped=true"
import script from "./InstantCreditForm.vue?vue&type=script&lang=js"
export * from "./InstantCreditForm.vue?vue&type=script&lang=js"
import style0 from "./InstantCreditForm.vue?vue&type=style&index=0&id=12c926da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c926da",
  null
  
)

export default component.exports